import React, { useState } from "react";
import "./settings.css";
import { Dropdown } from "primereact/dropdown";
import { TextInput } from "../../components/formElements/formElements";

const options = [
  { name: "Option 1", val: 0 },
  { name: "Option 2", val: 1 },
  { name: "Option 3", val: 2 },
];

const taxType = [
  { name: "GST", val: 0 },
  { name: "VAT", val: 1 },
  { name: "Sales Tax", val: 2 },
];
const propType = [
  { name: "Apartment", val: 0 },
  { name: "Villa", val: 1 },
  { name: "Plot", val: 2 },
  { name: "Commercial", val: 3 },
  { name: "Rental", val: 4 },
];

const Settings = () => {
  const [activityTab, setActivityTab] = useState(1);
  const [selectedOption, setSelectedOption] = useState(null);

  return (
    <div className="page-content settings-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              {/* <h4 className="mb-0 fw-semibold">Settings</h4>

              <div className="page-title-box-content">
                <button type="button" className="refresh-button" title="Reset">
                  <i className="ri-refresh-line"></i>
                </button>
                <form className="app-search">
                  <div className="position-relative">
                    <input type="search" className="form-control border-0" placeholder="Search..." autoComplete="off" name="searchValue" />
                    <i className="ri-search-line search-widget-icon"></i>
                  </div>
                </form>
              </div> */}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="settings-grid">
              <div className="settings-menu">
                <button
                  onClick={() => {
                    setActivityTab(1);
                  }}
                  className={activityTab === 1 ? "activityInfo-button active" : "activityInfo-button"}
                >
                  <i class="ri-organization-chart"></i>
                  <span>Organization</span>
                </button>
                <button
                  onClick={() => {
                    setActivityTab(2);
                  }}
                  className={activityTab === 2 ? "activityInfo-button active" : "activityInfo-button"}
                >
                  <i class="ri-user-6-line"></i>
                  <span>Users & Roles</span>
                </button>
                <button
                  onClick={() => {
                    setActivityTab(3);
                  }}
                  className={activityTab === 3 ? "activityInfo-button active" : "activityInfo-button"}
                >
                  <i className="ri-list-check"></i>
                  <span>Lead Management</span>
                </button>
                <button
                  onClick={() => {
                    setActivityTab(4);
                  }}
                  className={activityTab === 4 ? "activityInfo-button active" : "activityInfo-button"}
                >
                  <i class="ri-building-2-line"></i>
                  <span>Property & Inventory</span>
                </button>
                <button
                  onClick={() => {
                    setActivityTab(5);
                  }}
                  className={activityTab === 5 ? "activityInfo-button active" : "activityInfo-button"}
                >
                  <i class="ri-price-tag-2-line"></i>
                  <span>Sales & Commission</span>
                </button>
                <button
                  onClick={() => {
                    setActivityTab(6);
                  }}
                  className={activityTab === 6 ? "activityInfo-button active" : "activityInfo-button"}
                >
                  <i class="ri-p2p-line"></i>
                  <span>Communication</span>
                </button>
                <button
                  onClick={() => {
                    setActivityTab(7);
                  }}
                  className={activityTab === 7 ? "activityInfo-button active" : "activityInfo-button"}
                >
                  <i class="ri-flow-chart"></i>
                  <span>Automation & Workflow</span>
                </button>
                <button
                  onClick={() => {
                    setActivityTab(8);
                  }}
                  className={activityTab === 8 ? "activityInfo-button active" : "activityInfo-button"}
                >
                  <i class="ri-webhook-line"></i>
                  <span>Integrations</span>
                </button>
                <button
                  onClick={() => {
                    setActivityTab(9);
                  }}
                  className={activityTab === 9 ? "activityInfo-button active" : "activityInfo-button"}
                >
                  <i class="ri-receipt-line"></i>
                  <span>Billing & Subscription</span>
                </button>
                <button
                  onClick={() => {
                    setActivityTab(10);
                  }}
                  className={activityTab === 10 ? "activityInfo-button active" : "activityInfo-button"}
                >
                  <i class="ri-shield-line"></i>
                  <span>Security & Compliance</span>
                </button>
                <button
                  onClick={() => {
                    setActivityTab(11);
                  }}
                  className={activityTab === 11 ? "activityInfo-button active" : "activityInfo-button"}
                >
                  <i class="ri-database-2-line"></i>
                  <span>Data Management</span>
                </button>
                <button
                  onClick={() => {
                    setActivityTab(12);
                  }}
                  className={activityTab === 12 ? "activityInfo-button active" : "activityInfo-button"}
                >
                  <i class="ri-settings-4-line"></i>
                  <span>Customization</span>
                </button>
                <button
                  onClick={() => {
                    setActivityTab(13);
                  }}
                  className={activityTab === 13 ? "activityInfo-button active" : "activityInfo-button"}
                >
                  <i class="ri-customer-service-2-fill"></i>
                  <span>System & Support</span>
                </button>
              </div>
              <div className="settings-content">
                {activityTab === 1 && (
                  <>
                    <h4>Company Profile</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Company Name </label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Legal Business Name</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Website URL </label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Favicon </label>
                        <input type="file" className="form-control form-control-upload" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Logo (Light / Dark)</label>
                        <input type="file" className="form-control form-control-upload" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Brand Colors </label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>Business Info</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Industry Type </label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Default Currency </label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Time Zone </label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Date & Number Format </label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>Regional & Tax</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Country / State </label>
                        <Dropdown
                          value={selectedOption}
                          onChange={(e) => setSelectedOption(e.value)}
                          options={options}
                          optionLabel="name"
                          optionValue="val"
                          placeholder="Select Country"
                          filter
                          appendTo="self"
                          className="customised-dropdown"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Tax Type </label>
                        <Dropdown
                          value={selectedOption}
                          onChange={(e) => setSelectedOption(e.value)}
                          options={taxType}
                          optionLabel="name"
                          optionValue="val"
                          placeholder="Select tax type"
                          appendTo="self"
                          className="customised-dropdown"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Tax % Rules </label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Invoice Prefix </label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </>
                )}
                {activityTab === 2 && (
                  <>
                    <h4>Users</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Invite Users</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group form-option">
                        <label className="form-label d-block mb-2">Activation Status</label>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="tourStatus" id="inlineRadio1" value="Activate" />
                          <label className="form-check-label" htmlFor="inlineRadio1">
                            Activate
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="tourStatus" id="inlineRadio2" value="Deactivate" />
                          <label className="form-check-label" htmlFor="inlineRadio2">
                            Deactivate
                          </label>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label">Reset Password</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Login History</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Device Sessions</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>Roles</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Admin</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Manager</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Agent</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Marketing</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Custom Roles</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>Permissions</h4>
                    <div className="form-group-grid">
                      <div className="form-group form-option">
                        <label className="form-label d-block">Module-level access</label>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="moduleLevel" id="moduleLevel" value="Yes" />
                          <label className="form-check-label" htmlFor="moduleLevel">
                            Yes
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="moduleLevel" id="moduleLevel2" value="No" />
                          <label className="form-check-label" htmlFor="moduleLevel2">
                            No
                          </label>
                        </div>
                      </div>
                      <div className="form-group form-option">
                        <label className="form-label d-block">Action-level permissions</label>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="actionLevel" id="actionLevel" value="Yes" />
                          <label className="form-check-label" htmlFor="actionLevel">
                            Yes
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="actionLevel" id="actionLevel2" value="No" />
                          <label className="form-check-label" htmlFor="actionLevel2">
                            No
                          </label>
                        </div>
                      </div>
                      <div className="form-group form-option">
                        <label className="form-label d-block">Field-level security (Enterprise)</label>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="fieldLevel" id="fieldLevel" value="Yes" />
                          <label className="form-check-label" htmlFor="fieldLevel">
                            Yes
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="fieldLevel" id="fieldLevel2" value="No" />
                          <label className="form-check-label" htmlFor="fieldLevel2">
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {activityTab === 3 && (
                  <>
                    <h4>Lead Sources</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Website</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Portals</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Walk-ins</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Campaigns</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Channel Partners</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>Lead Pipeline</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Custom Statuses</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Drag-drop reorder</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Probability %</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>Lead Assignment</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Auto Assign (Round-Robin)</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Geo-based routing</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Working hours rules</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>Lead Scoring</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Budget</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Property type</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Engagement level</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </>
                )}
                {activityTab === 4 && (
                  <>
                    <h4>Property Types</h4>
                    <div className="form-group-grid">
                      <div className="form-group form-group-full">
                        <div className="row">
                          <div className="col-lg-2">
                            <div className="mb-2">
                              <input className="form-check-input" type="checkbox" value="" id="defaultCheck31" />
                              <label className="form-check-label ms-2" for="defaultCheck31">
                                Apartment
                              </label>
                            </div>
                          </div>
                          <div class="col-lg-2">
                            <div class="mb-2">
                              <input class="form-check-input" type="checkbox" value="" id="defaultCheck2" />
                              <label class="form-check-label ms-2" for="defaultCheck2">
                                Villa
                              </label>
                            </div>
                          </div>
                          <div class="col-lg-2">
                            <div class="mb-2">
                              <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" />
                              <label class="form-check-label ms-2" for="defaultCheck1">
                                Plot
                              </label>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <div class="mb-2">
                              <input class="form-check-input" type="checkbox" value="" id="defaultCheck3" />
                              <label class="form-check-label ms-2" for="defaultCheck3">
                                Commercial
                              </label>
                            </div>
                          </div>
                          <div class="col-lg-2">
                            <div class="mb-2">
                              <input class="form-check-input" type="checkbox" value="" id="defaultCheck4" />
                              <label class="form-check-label ms-2" for="defaultCheck4">
                                Rental
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h4>Inventory Structure</h4>
                    <div className="form-group-grid">
                      <div className="form-group form-group-full">
                        <div className="row">
                          <div className="col-lg-2">
                            <div className="mb-2">
                              <input className="form-check-input" type="checkbox" value="" id="defaultCheck31" />
                              <label className="form-check-label ms-2" for="defaultCheck31">
                                Projects
                              </label>
                            </div>
                          </div>
                          <div class="col-lg-2">
                            <div class="mb-2">
                              <input class="form-check-input" type="checkbox" value="" id="defaultCheck2" />
                              <label class="form-check-label ms-2" for="defaultCheck2">
                                Towers
                              </label>
                            </div>
                          </div>
                          <div class="col-lg-2">
                            <div class="mb-2">
                              <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" />
                              <label class="form-check-label ms-2" for="defaultCheck1">
                                Floors
                              </label>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <div class="mb-2">
                              <input class="form-check-input" type="checkbox" value="" id="defaultCheck3" />
                              <label class="form-check-label ms-2" for="defaultCheck3">
                                Units
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label">Unit Status </label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Availability Rules </label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>Attributes</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Area Units</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Facing</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Furnishing</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Possession Status</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>Amenities</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Custom amenity builder</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Icon mapping</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </>
                )}
                {activityTab === 5 && (
                  <>
                    <h4>Deal Stages</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Custom stages</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Probability mapping</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>Commission Rules</h4>
                    <div className="form-group form-option">
                      <label className="form-label d-block">Commission Type</label>
                      <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="tourStatus" id="comType1" value="Percentage" />
                        <label className="form-check-label" htmlFor="comType1">
                          Percentage %
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="tourStatus" id="comType2" value="Flat Fee" />
                        <label className="form-check-label" htmlFor="comType2">
                          Flat Fee
                        </label>
                      </div>
                    </div>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Channel Partner Commission</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Tier-based commission</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>Discounts</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Max Discount %</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Approval hierarchy</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Auto-lock after approval</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>Payment Milestones</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Booking</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Agreement</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Possession</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </>
                )}
                {activityTab === 6 && (
                  <>
                    <h4>Email</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">SMTP / API</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Email Templates</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Signature Control</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>SMS</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Provider Setup</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Sender ID</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Template Approval</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>WhatsApp</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Official API</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Template Mapping</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Automation triggers</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>Calls</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Call Tracking</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">IVR</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Recording Storage</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </>
                )}
                {activityTab === 7 && (
                  <>
                    <h4>Workflow Builder</h4>
                    <div className="form-group-grid">
                      <div className="form-group form-option">
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="workflow" id="workflow1" value="Percentage" />
                          <label className="form-check-label" htmlFor="workflow1">
                            Trigger
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="workflow" id="workflow2" value="Flat Fee" />
                          <label className="form-check-label" htmlFor="workflow2">
                            Condition
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="workflow" id="workflow3" value="Flat Fee" />
                          <label className="form-check-label" htmlFor="workflow3">
                            Action
                          </label>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label">Lead status automation</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Task creation rules</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>SLA Rules</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">First response time</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Escalation rules</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>Alerts</h4>
                    <div className="form-group form-group-full">
                      <div className="row">
                        <div className="col-lg-2">
                          <div className="mb-2">
                            <input className="form-check-input" type="checkbox" value="" id="defaultCheck31" />
                            <label className="form-check-label ms-2" for="defaultCheck31">
                              Email
                            </label>
                          </div>
                        </div>
                        <div class="col-lg-2">
                          <div class="mb-2">
                            <input class="form-check-input" type="checkbox" value="" id="defaultCheck2" />
                            <label class="form-check-label ms-2" for="defaultCheck2">
                              In-app
                            </label>
                          </div>
                        </div>
                        <div class="col-lg-2">
                          <div class="mb-2">
                            <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" />
                            <label class="form-check-label ms-2" for="defaultCheck1">
                              Mobile push
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {activityTab === 8 && (
                  <>
                    <h4>Property Portals</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">API Keys</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Sync Frequency</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Field Mapping</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>Website</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Form integrations</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Landing pages</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>Finance</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Payment Gateways</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Accounting tools</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <h4>Developer</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">API Tokens</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Webhooks</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Rate limits</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </>
                )}
                {activityTab === 9 && (
                  <>
                    <h4>Plan Details</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Current Plan</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Feature Limits</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="form-group">
                        <TextInput id="userLimits" label="User Limits" name="userLimits" />
                      </div>
                    </div>
                    <h4>Usage Metrics</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <TextInput id="metricLeads" label="Metric Leads" name="metricLeads" />
                      </div>
                      <div className="form-group">
                        <TextInput id="storage" label="Storage" name="storage" />
                      </div>
                      <div className="form-group">
                        <TextInput id="apiCalls" label="API calls" name="apiCalls" />
                      </div>
                    </div>
                    <h4>Billing</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <TextInput id="invoices" label="Invoices" name="invoices" />
                      </div>
                      <div className="form-group">
                        <TextInput id="paymentHistory" label="Payment History" name="paymentHistory" />
                      </div>
                      <div className="form-group">
                        <TextInput id="autoRenewal" label="Auto-renewal" name="autoRenewal" />
                      </div>
                    </div>
                    <h4>Add-Ons</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <TextInput id="whatsappCredits" label="WhatsApp credits" name="whatsappCredits" />
                      </div>
                      <div className="form-group">
                        <TextInput id="aiFeatures" label="AI features" name="aiFeatures" />
                      </div>
                      <div className="form-group">
                        <TextInput id="extraStorage" label="Extra storage" name="extraStorage" />
                      </div>
                    </div>
                  </>
                )}
                {activityTab === 10 && (
                  <>
                    <h4>Authentication</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <TextInput id="passwordPolicy" label="Password Policy" name="passwordPolicy" />
                      </div>
                      <div className="form-group">
                        <TextInput id="twoFactorAuth" label="2FA / MFA" name="twoFactorAuth" />
                      </div>
                      <div className="form-group">
                        <TextInput id="ssoEnterprise" label="SSO (Enterprise)" name="ssoEnterprise" />
                      </div>
                    </div>
                    <h4>Access Control</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <TextInput id="ipWhitelisting" label="IP Whitelisting" name="ipWhitelisting" />
                      </div>
                      <div className="form-group">
                        <TextInput id="sessionTimeout" label="Session Timeout" name="sessionTimeout" />
                      </div>
                    </div>
                    <h4>Compliance</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <TextInput id="gdpr" label="GDPR" name="gdpr" />
                      </div>
                      <div className="form-group">
                        <TextInput id="soc2" label="SOC-2" name="soc2" />
                      </div>
                      <div className="form-group">
                        <TextInput id="dataResidency" label="Data Residency" name="dataResidency" />
                      </div>
                    </div>
                    <h4>Audit Logs</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <TextInput id="userActions" label="User actions" name="userActions" />
                      </div>
                      <div className="form-group">
                        <TextInput id="settingChanges" label="Setting changes" name="settingChanges" />
                      </div>
                      <div className="form-group">
                        <TextInput id="loginHistory" label="Login history" name="loginHistory" />
                      </div>
                    </div>
                  </>
                )}
                {activityTab === 11 && (
                  <>
                    <h4>Import / Export</h4>
                    <div className="form-group-grid">
                      <div className="form-group form-option form-group-full">
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="importExport" id="importExport1" value="laeds" />
                          <label className="form-check-label" htmlFor="importExport1">
                            Leads
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="importExport" id="importExport2" value="properties" />
                          <label className="form-check-label" htmlFor="importExport2">
                            Properties
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="importExport" id="importExport3" value="deals" />
                          <label className="form-check-label" htmlFor="importExport3">
                            Deals
                          </label>
                        </div>
                      </div>
                    </div>
                    <h4>Backup</h4>
                    <div className="form-group-grid">
                      <div className="form-group form-option form-group-full">
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="backup" id="backup1" value="automated" />
                          <label className="form-check-label" htmlFor="backup1">
                            Automated
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="backup" id="backup2" value="manual" />
                          <label className="form-check-label" htmlFor="backup2">
                            Manual
                          </label>
                        </div>
                      </div>
                    </div>
                    <h4>Retention</h4>
                    <div className="form-group-grid">
                      <div className="form-group form-option form-group-full">
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="retention" id="retention1" value="Percentage" />
                          <label className="form-check-label" htmlFor="retention1">
                            Data retention rules
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="retention" id="retention2" value="Flat Fee" />
                          <label className="form-check-label" htmlFor="retention2">
                            Archive policies
                          </label>
                        </div>
                      </div>
                    </div>
                    <h4>Delete Requests</h4>
                    <div className="form-group-grid">
                      <div className="form-group form-option form-group-full">
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="delRequests" id="delRequests1" value="Percentage" />
                          <label className="form-check-label" htmlFor="delRequests1">
                            Soft delete
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="delRequests" id="delRequests2" value="Flat Fee" />
                          <label className="form-check-label" htmlFor="delRequests2">
                            Hard delete approvals
                          </label>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {activityTab === 12 && (
                  <>
                    <h4>Branding</h4>
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">Logo</label>
                        <input type="file" className="form-control form-control-upload" />
                      </div>
                      <div className="form-group">
                        <TextInput id="brandColors" label="Colors" name="brandColors" />
                      </div>
                      <div className="form-group">
                        <TextInput id="loginPage" label="Login Page" name="loginPage" />
                      </div>
                    </div>
                    <h4>Custom Fields</h4>
                    <div className="form-group-grid">
                      <div className="form-group form-option form-group-full">
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="importExport" id="importExport1" value="laeds" />
                          <label className="form-check-label" htmlFor="importExport1">
                            Leads
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="importExport" id="importExport2" value="properties" />
                          <label className="form-check-label" htmlFor="importExport2">
                            Properties
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="importExport" id="importExport3" value="deals" />
                          <label className="form-check-label" htmlFor="importExport3">
                            Deals
                          </label>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {activityTab === 13 && (
                  <>
                    <h4>System & Support</h4>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
